import React, { useContext, useEffect, useState } from "react";

import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import GatsbyImageWrapper from "../GatsbyImageWrapper";
import { ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/servicesContext";
import { IProduct } from "@sbi-international/boutik.gatsby.plugin.services";

import PriceDisplay from "../productSummary/PriceDisplay";
import { AddItemButton } from "@sbi-international/boutik.gatsby.plugin.checkout";
import { getAvailability } from "../../utils/productAvailabilityInfo";
import { ProductPrice } from "../price/ProductPrice";
import { ProductStock } from "@sbi-international/boutik.gatsby.plugin.components";

type DisplayOptions = {
    product: Queries.ProductsJson;
    option: Queries.ProductsJsonOptions;
};

type ProductOptionItemProps = {
    displayOption: DisplayOptions;
    lang: string;
};

export default function ProductOptionItem(props: ProductOptionItemProps) {
    const { displayOption, lang } = props;
    const [productData, setProductData] = useState<IProduct>();

    const servicesContext = useContext(ServicesContext);

    const productService = servicesContext?.magento.productService;

    const { navigateTranslated, currentLocale } = usePageLocalization();

    const slugUrl: string = (
        displayOption.product?.slug ? displayOption.product?.slug?.[currentLocale] : ""
    ) as string;
    const sku = displayOption.option.code ? displayOption.option.code : "";

    useEffect(() => {
        productService.operations.getProduct(displayOption.product.code ?? "").then((product) => {
            if (product) {
                setProductData(product);
            }
        });
    }, [displayOption]);

    return (
        <div className="product_option" key={displayOption.option.id}>
            <div
                className="product_option_image"
                onClick={() => {
                    navigateTranslated(slugUrl);
                }}
            >
                <GatsbyImageWrapper fields={displayOption?.product?.fields ?? undefined} />
            </div>
            <div className="product_option_details">
                <p>
                    <span
                        className="title"
                        onClick={() => {
                            navigateTranslated(slugUrl);
                        }}
                    >
                        {displayOption?.option?.title?.[
                            lang as keyof typeof displayOption.option.title
                        ] ?? ""}
                    </span>
                    <span className="code">{displayOption.option.code}</span>
                </p>
                <ProductPrice
                    currentPrice={productData?.currentPrice}
                    prefixClassName="product-option-item"
                />            
                <ProductStock currentStock={productData?.currentStock} prefixClassName="product-option-item" type="small" isCustomMade={false} />
            </div>
            <AddItemButton
                type={"small"}
                product={productData}              
            />
        </div>
    );
}
